module.exports = __webpack_public_path__ + "img/figure-9.e1aab047.png";